'use client';

import { File01Icon } from '@terra/ui-icons';
import { EmptyState } from '../EmptyState';

export const getRequestsUnavailableDescription = ({
  errorMessage,
  requests,
  endpointId,
}: {
  errorMessage?: string;
  requests: { length: number } | null;
  endpointId?: string;
}): string => {
  if (errorMessage) {
    return `Failed to load requests: ${errorMessage}`;
  }

  if (!requests) {
    return endpointId
      ? 'No HAR data available for this endpoint'
      : 'No HAR data available for this application';
  }

  if (requests.length === 0) {
    return endpointId
      ? 'No requests found for this endpoint'
      : 'No requests found for this application';
  }

  return 'No request data available';
};

export function RequestsContentUnavailable({
  errorMessage,
  requests,
  endpointId,
  isLoading,
}: {
  errorMessage?: string;
  requests: { length: number } | null;
  endpointId?: string;
  isLoading: boolean;
}) {
  return (
    <EmptyState
      icon={File01Icon}
      title="No Request Data Available"
      description={getRequestsUnavailableDescription({
        errorMessage,
        requests,
        endpointId,
      })}
      isLoading={isLoading}
    />
  );
}
